export const zipCodeValidation = (state) => (zipString) => {
    if(zipString && state) {
        if(zipString === '' || state === '') {
            return true;
        }        
        if (!(zipString.length >= 5)) {
            return true;
        }
        
        zipString = zipString.substring(0, 5);
    
        var zipcode = parseInt(zipString, 10);        
        if (zipcode >= 35000 && zipcode <= 36999) {
            return state === 'AL';
        } else if (zipcode >= 99500 && zipcode <= 99999) {
            return state === 'AK';
        } else if (zipcode >= 85000 && zipcode <= 86999) {
            return state === 'AZ';
        } else if (zipcode >= 71600 && zipcode <= 72999) {
            return state === 'AR';
        } else if (zipcode >= 90000 && zipcode <= 96699) {
            return state === 'CA';
        } else if (zipcode >= 80000 && zipcode <= 81999) {
            return state === 'CO';
        } else if ((zipcode >= 6000 && zipcode <= 6389) || (zipcode >= 6391 && zipcode <= 6999)) {
            return state === 'CT';
        } else if (zipcode >= 19700 && zipcode <= 19999) {
            return state === 'DE';
        } else if (zipcode >= 32000 && zipcode <= 34999) {
            return state === 'FL';
        } else if ( (zipcode >= 30000 && zipcode <= 31999) || (zipcode >= 39800 && zipcode <= 39999) ) {
            return state === 'GA';
        } else if (zipcode >= 96700 && zipcode <= 96999) {
            return state === 'HI';
        } else if (zipcode >= 83200 && zipcode <= 83999) {
            return state === 'ID';
        } else if (zipcode >= 60000 && zipcode <= 62999) {
            return state === 'IL';
        } else if (zipcode >= 46000 && zipcode <= 47999) {
            return state === 'IN';
        } else if (zipcode >= 50000 && zipcode <= 52999) {
            return state === 'IA';
        } else if (zipcode >= 66000 && zipcode <= 67999) {
            return state === 'KS';
        } else if (zipcode >= 40000 && zipcode <= 42999) {
            return state === 'KY';
        } else if (zipcode >= 70000 && zipcode <= 71599) {
            return state === 'LA';
        } else if (zipcode >= 3900 && zipcode <= 4999) {
            return state === 'ME';
        } else if (zipcode >= 20600 && zipcode <= 21999) {
            return state === 'MD';
        } else if ( (zipcode >= 1000 && zipcode <= 2799) || (zipcode == 5501) || (zipcode == 5544 ) ) {
            return state === 'MA';
        } else if (zipcode >= 48000 && zipcode <= 49999) {
            return state === 'MI';
        } else if (zipcode >= 55000 && zipcode <= 56899) {
            return state === 'MN';
        } else if (zipcode >= 38600 && zipcode <= 39999) {
            return state === 'MS';
        } else if (zipcode >= 63000 && zipcode <= 65999) {
            return state === 'MO';
        } else if (zipcode >= 59000 && zipcode <= 59999) {
            return state === 'MT';
        } else if (zipcode >= 27000 && zipcode <= 28999) {
            return state === 'NC';
        } else if (zipcode >= 58000 && zipcode <= 58999) {
            return state === 'ND';
        } else if (zipcode >= 68000 && zipcode <= 69999) {
            return state === 'NE';
        } else if (zipcode >= 88900 && zipcode <= 89999) {
            return state === 'NV';
        } else if (zipcode >= 3000 && zipcode <= 3899) {
            return state === 'NH';
        } else if (zipcode >= 7000 && zipcode <= 8999) {
            return state === 'NJ';
        } else if (zipcode >= 87000 && zipcode <= 88499) {
            return state === 'NM';
        } else if ( (zipcode >= 10000 && zipcode <= 14999) || (zipcode == 6390) || (zipcode == 501) || (zipcode == 544) ) {
            return state === 'NY';
        } else if (zipcode >= 43000 && zipcode <= 45999) {
            return state === 'OH';
        } else if ((zipcode >= 73000 && zipcode <= 73199) || (zipcode >= 73400 && zipcode <= 74999) ) {
            return state === 'OK';
        } else if (zipcode >= 97000 && zipcode <= 97999) {
            return state === 'OR';
        } else if (zipcode >= 15000 && zipcode <= 19699) {
            return state === 'PA';
        } else if (zipcode >= 300 && zipcode <= 999) {
            return state === 'PR';
        } else if (zipcode >= 2800 && zipcode <= 2999) {
            return state === 'RI';
        } else if (zipcode >= 29000 && zipcode <= 29999) {
            return state === 'SC';
        } else if (zipcode >= 57000 && zipcode <= 57999) {
            return state === 'SD';
        } else if (zipcode >= 37000 && zipcode <= 38599) {
            return state === 'TN';
        } else if ( (zipcode >= 75000 && zipcode <= 79999) || (zipcode >= 73301 && zipcode <= 73399) ||  (zipcode >= 88500 && zipcode <= 88599) ) {
            return state === 'TX';
        } else if (zipcode >= 84000 && zipcode <= 84999) {
            return state === 'UT';
        } else if (zipcode >= 5000 && zipcode <= 5999) {
            return state === 'VT';
        } else if ( (zipcode >= 20100 && zipcode <= 20199) || (zipcode >= 22000 && zipcode <= 24699) || (zipcode == 20598) ) {
            return state === 'VA';
        } else if ( (zipcode >= 20000 && zipcode <= 20099) || (zipcode >= 20200 && zipcode <= 20599) || (zipcode >= 56900 && zipcode <= 56999) ) {
            return state === 'DC';
        } else if (zipcode >= 98000 && zipcode <= 99499) {
            return state === 'WA';
        } else if (zipcode >= 24700 && zipcode <= 26999) {
            return state === 'WV';
        } else if (zipcode >= 53000 && zipcode <= 54999) {
            return state === 'WI';
        } else if (zipcode >= 82000 && zipcode <= 83199) {
            return state === 'WY';
        } else {
            console.log('no state found matching', zipcode);
            return false;
        }
    }

    return true;
}

export function isValidRoutingNumber(value) {
    if(value) {
        var n = 0;
        for (var i = 0; i < value.length; i += 3) {
            n += parseInt(value.charAt(i), 10) * 3
                + parseInt(value.charAt(i + 1), 10) * 7
                + parseInt(value.charAt(i + 2), 10);
        }

        // If the resulting sum is an even multiple of ten (but not zero),
        // the aba routing number is good.

        if (n !== 0 && n % 10 === 0) {
            return true;
        } else {
            return false;
        }            
    } else {
        return true; // It's valid if it's blank, a required validator can check this separately
    }
}